import React, { useReducer, useEffect } from 'react';
import { Box, Tooltip, TextField } from '@mui/material';
import DefaultModal from '../Utils/DefaultModal';
import { api } from '../../services/api';
import { lockedReducer } from '../Utils/reducers';
import ColorButton from '../Buttons/ColorButton';
import toast from 'react-hot-toast';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import validateData from './validateRotasRegiao';
import MegaAutoComplete from '../Utils/megautocomplete';
import TransferTable from '../Utils/transferTable';

const url = '/frete/'
const submit = async (setLoader, data, getData, handleClose) => {

    setLoader(true)
    let res = null
    if (data.id)
        res = await api.patch(`${url}${data.id}/`, data)
    else
        res = await api.post(url, data)
    if (res.status === 200) {
        toast.success(`Rota/Região ${!data.id ? 'adicionado' : 'editado'} com sucesso`)
        getData()
    } else {
        toast.error(res.data.detail)
        setLoader(false)
        return
    }
    setLoader(false)
    handleClose()
}

const getTipos = async (setLoader, setState) => {
    setLoader(true)
    const res = await api.get(url + 'tipo')
    if (res.status === 200) {
        setState({ tiposFretes: res.data })
    }
    setLoader(false)
}

const getMunicipios = async (data, setState, setLoader) => {

    if (data?.id) {
        setLoader(true)
        const res = await api.post(`/frete/municipios/${data.id}`)
        if (res.status === 200) {
            setState({ municipios: res.data, municipios_saved: [] })
        }
        setLoader(false)
    } else {
        setState({ municipios: [], municipios_saved: [] })
    }


}

const loadRetrieve = async (id, id_estado, setState, setLoader) => {
    setLoader(true)
    const res = await api.get(url + 'municipio/' + `${id}/`)
    if (res.status === 200) {
        const res_municipio = await api.post(`/frete/municipios/${id_estado}`)
        if (res_municipio.status === 200) {
            const idsExistentes = res.data.map(item => item.nome);

            const municipios_restantes = res_municipio.data.filter(item => !idsExistentes.includes(item.nome));

            setState({ municipios: municipios_restantes, municipios_saved: res.data })
        }
    }
    setLoader(false)
}

const getcolumnsTransfer = () => {
    const columns = []
    columns.push({ field: 'nome', headerName: 'Município', flex: 0.1, width: 100 })
    return columns
}

const toRight = (table, setState, data1, data2) => {
    const selectedRows = typeof table?.apiRef?.current?.getSelectedRows === 'function'
        ? table.apiRef.current.getSelectedRows()
        : null;

    const municipios = Array.from(selectedRows.values())
        .filter(row => row)
        .map(row => row.nome);

    const municipios_filtrados_adicionados = data1.filter(item => municipios.includes(item.nome));

    const newMunicipios = [...municipios_filtrados_adicionados, ...data2].sort((a, b) =>
        a.nome.localeCompare(b.nome)
    );

    const municipios_filtrados_removidos = data1
        .filter(item => !municipios.includes(item.nome))
        .sort((a, b) => a.nome.localeCompare(b.nome));

    setState({
        municipios: municipios_filtrados_removidos,
        municipios_saved: newMunicipios,
    });

    table.apiRef.current.setRowSelectionModel([]);
};

const toLeft = (table, setState, data1, data2) => {
    const selectedRows = typeof table?.apiRef?.current?.getSelectedRows === 'function'
        ? table.apiRef.current.getSelectedRows()
        : null;

    const municipios = Array.from(selectedRows.values())
        .filter(row => row)
        .map(row => row.nome);

    const municipios_filtrados_adicionados = data2.filter(item => municipios.includes(item.nome));

    const newMunicipios = [...municipios_filtrados_adicionados, ...data1].sort((a, b) =>
        a.nome.localeCompare(b.nome)
    );

    const municipios_filtrados_removidos = data2
        .filter(item => !municipios.includes(item.nome))
        .sort((a, b) => a.nome.localeCompare(b.nome));

    setState({
        municipios: newMunicipios,
        municipios_saved: municipios_filtrados_removidos,
    });

    table.apiRef.current.setRowSelectionModel([]);
};

const getTitle = (data) => {
    if (data?.id)
        return 'Editar'
    return 'Adicionar'
}

const EditRotasRegioes = ({ data, handleClose, reloadData, setLoader }) => {

    const [state, setState] = useReducer(lockedReducer, {
        rows: [],
        editRow: null,
        id_tipo: null,
        tiposFretes: [],
        estado: null,
        municipios: [],
        municipios_saved: [],
        urlMunicipio: '',
        nome_rota_regiao: '',
        ...data,
        id: data.id ? data.id : 0
    })

    const validTable = validateData(state)

    useEffect(() => {
        getTipos(setLoader, setState)
        if (data.id)
            loadRetrieve(data.id, data.id_estado, setState, setLoader)
    }, [setLoader, data.id])

    return (
        <>
            <DefaultModal
                dialogProps={{
                    sx: {
                        '& .MuiPaper-root': {
                            maxWidth: 'unset',
                            maxHeight: 'unset',
                            width: '95%',
                            height: '95%',
                            margin: '0px',

                            '@media (min-width: 1600px)': {
                                width: '80%', // Largura para telas maiores
                                height: '80%', // Altura para telas maiores
                            },
                        }
                    }
                }}
                handleClose={handleClose}
                open={true}
                title={`${getTitle(state)} Rota/Região`}
                content={
                    <Box className='item-content-modal noborder'>


                        <Box className='item-profile-row'>
                            <TextField
                                id="nomeRotaRegiao"
                                type="text"
                                label="Nome rota/região"
                                size='small'
                                value={state.nome_rota_regiao}
                                onChange={(e) => { setState({ nome_rota_regiao: e.target.value }) }}
                                fullWidth={false}
                                sx={{ width: '100%' }}
                            />

                            <FormControl size="small">
                                <InputLabel id="demo-simple-select-label">Tipo</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Tipo"
                                    value={state.id_tipo}
                                    onChange={(e) => setState({ id_tipo: e.target.value })}
                                    sx={{ width: '100%' }}
                                >

                                    {
                                        Object.entries(state.tiposFretes).map(([key, value]) => (
                                            <MenuItem key={key} value={key}>{value.nome}</MenuItem>
                                        ))
                                    }

                                </Select>
                            </FormControl>

                            <MegaAutoComplete
                                multiple={false}
                                value={state.estado}
                                onChange={(data) => { setState({ estado: data }); getMunicipios(data, setState, setLoader) }}
                                noOptionsText={'Digite para procurar um estado'}
                                timeoutUrl='/frete/estados/'
                                timeoutParam='label'
                                label='Estado'
                            />

                        </Box>
                        <Box>
                            <TransferTable getcolumns1={getcolumnsTransfer} getcolumns2={getcolumnsTransfer}
                                data1={state.municipios} data2={state.municipios_saved}
                                setState={setState} toRight={toRight} toLeft={toLeft}
                            />
                        </Box>

                    </Box>
                }

                action={

                    <Tooltip title={validTable} placement="left">
                        <span>
                            <ColorButton disabled={validTable} onClick={() => submit(setLoader, state, reloadData, handleClose)}>Salvar</ColorButton>
                        </span>
                    </Tooltip>

                }
            />

        </>
    )
}

export default EditRotasRegioes;